import PropTypes from 'prop-types';
import React from 'react';
import { fieldTypeLabel } from '../../shared/fieldTypes';
import { fieldName, LOCKED_TIP } from '../desktop/FieldCard';
import FieldProperties from '../properties/FieldProperties';
import PaneHeader from './PaneHeader';

// Phone "Edit field" pane (plan §5.7): full screen, the field's name and
// type, a ⋯ menu (the field actions minus Edit) and Done; the body is the
// full desktop Properties panel. A locked field (w9-plan §6.5) says so in
// the sub line; the panel below shows its summary without editors.
const EditPane = ({ field, locked, onMore, onDone, headingRef }) => (
  <section aria-label={`Edit ${fieldName(field)}`}>
    <PaneHeader
      title={fieldName(field)}
      sub={`${fieldTypeLabel(field)} field${locked ? ` · ${LOCKED_TIP}` : ''}`}
      onMore={onMore}
      moreLabel={`More actions for ${fieldName(field)}`}
      onDone={onDone}
      headingRef={headingRef}
    />
    <FieldProperties field={field} showHeader={false} />
  </section>
);

EditPane.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  locked: PropTypes.bool,
  onMore: PropTypes.func,
  onDone: PropTypes.func.isRequired,
  headingRef: PropTypes.shape({ current: PropTypes.any }),
};

EditPane.defaultProps = {
  locked: false,
  onMore: undefined,
  headingRef: undefined,
};

export default EditPane;
